import { Routes } from '@angular/router';
import { adminGuard } from './services/guards/admin.guard';

export const APP_ROUTES: Routes = [
  {
    path: '', redirectTo: '/frontPage', pathMatch: 'full'
  },
  {
    path: 'frontPage',
    title: 'BinView',
    loadComponent: () => import('./front-page/front-page.component').then(c => c.FrontPageComponent)
  },
  {
    path: 'acquisition',
    data: { preload: true },
    loadChildren: () => import('./acquisition-table-generator/acquisition-table-generator.routes')
      .then(m => m.ACQUISITION_ROUTES)
  },
  {
    path: 'experiment',
    data: { preload: true },
    loadChildren: () => import('./experiment/experiment.routes').then(m => m.EXPERIMENT_ROUTES)
  },
  {
    path: 'scheduler',
    loadChildren: () => import('./scheduler/scheduler.routes').then(m => m.SCHEDULER_ROUTES)
  },
  {
    path: 'binview',
    data: { preload: true },
    loadChildren: () => import('./binview/bin-view.routes').then(m => m.BIN_VIEW_ROUTES)
  },
  {
    path: 'standards',
    loadChildren: () => import('./standards-mgmt/standards-mgmt.routes').then(m => m.STANDARDS_MGMT_ROUTES)
  },
  {
    path: 'utility',
    loadChildren: () => import('./utility/utility.routes').then(m => m.UTILITY_ROUTES)
  },
  {
    path: 'monitor',
    loadChildren: () => import('./qcmonitor/qc-monitor.routes').then(m => m.QC_MONITOR_ROUTES)
  },
  {
    path: 'audit',
    loadChildren: () => import('./audit-logs/audit-logs.routes').then(m => m.AUDIT_LOGS_ROUTES)
  },
  {
    path: 'diags',
    loadChildren: () => import('./diagnostics/diagnostics.routes').then(m => m.DIAGNOSTICS_ROUTES)
  },
  {
    path: 'binview/hidden',
    title: 'BinView Hidden Compounds',
    loadComponent: () => import('./hidden-compounds/hidden-compounds/hidden-compounds.component')
      .then(m => m.HiddenCompoundsComponent)
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES)
  },
  {
    path: '**',
    title: 'BinView - Page Not Found',
    loadComponent: () => import('./not-found/not-found.component').then(c => c.NotFoundComponent)
  }
];
